export const NEW_LEASE_AGREEMENT = 'new_lease_agreement'
export const LEASE_AGREEMENT_AMENDMENT = 'lease_agreement_amendment'
export const LEASE_TERMINATION_AGREEMENT = 'lease_termination_agreement'
export const OTHER = 'other'

export const ALL_REQUEST_LEASE_TYPES = [
  NEW_LEASE_AGREEMENT,
  LEASE_AGREEMENT_AMENDMENT,
  LEASE_TERMINATION_AGREEMENT,
  OTHER,
] as const

export type RequestLeaseType = (typeof ALL_REQUEST_LEASE_TYPES)[number]
